import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';

import properties from '../../../modules/ajio-util/properties';

const cx = classNames.bind(styles);

const BackArrow = (props) => {
  const {isFleek = false,style={}} = props
  return (
    <div 
    className={cx('backIcon')} 
    tabIndex={0}
    aria-label="Back"
    role='button'
    style={style}
    >
      <img
        alt=""
        aria-hidden="true"
        src={`${properties.getProperty('imageBaseUrl')}/static/img/${isFleek ? 'back-arrow-pdp.svg' :'back-arrow-refresh.svg'}`}
      />
    </div>
  );
};

export default BackArrow;
